var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCronosWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3325 3L4.41602 6.41614V13.2461L10.3325 16.66L16.2443 13.2461V6.41614L10.3325 3ZM14.4927 12.2341L10.3325 14.636L6.16988 12.2341V7.42588L10.3325 5.02404L14.4927 7.42588V12.2341Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0913 11.426L10.33 13.0196L7.56641 11.426V8.23651L10.33 6.64062L13.0913 8.23651L11.9419 8.9005L10.33 7.96862L8.7181 8.9005V10.7597L10.33 11.6916L11.9419 10.7597L13.0913 11.426Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCronosWhite);
export default __webpack_public_path__ + "static/media/cronos-white.0536cd51ef40558a1e42a8fdbae52737.svg";
export { ForwardRef as ReactComponent };